<template>
  <div>
    <div>
      <div
        class="modal fade show"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        v-if="workflowStore.moveModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Move to Folder</h5>
            </div>
            <div class="modal-body">
              <h6>Folder List</h6>
              <select class="form-control show-tick">
                <option>select folder</option>
                <option
                  :value="folder.name"
                  v-for="folder in folders"
                  :key="folder.id"
                >
                  {{ folder.name }}
                </option>
              </select>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                style="background: #10948b"
              >
                Move
              </button>
              <button
                type="button"
                class="btn btn-default"
                @click="showModal('move', 'close')"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="modal-backdrop show" v-if="$store.state.backdrop"></div> -->
  </div>
</template>

<script>
export default {
  name: "moveFolder",
  props: ["propworkflow"],
  data() {
    return {
      folders: [],
      workflows: [],
    };
  },
  created() {
    this.folders = this.$store.state.workflowStore.folders;
    this.workflows = this.$store.state.workflowStore.workflows;
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
  },
  methods: {
    // showModal() {
    //   this.$store.state.workflowStore.modalState = false;
    //   this.$store.state.backdrop = false;
    // },
    showModal(tag, status) {
      var param = {};

      this.$store.dispatch("showModal", {
        params: param,
        tag: tag,
        status: status,
      });
      
      document.getElementsByClassName('overlay')[0].style.display = "none"

    },
  },
};
</script>
